import { Link } from "react-router-dom";
import portada from "../../../assets/img/excursión-poprtada.png";

const CargaExcursion = () => {

  return (
    <div className="mx-auto md:w-[80%] w-full bg-white rounded-lg shadow-sm border">
      <div className="grid lg:grid-cols-2 gap-10 py-5 px-5">
        <div>
          <span className="text-primary font-bold text-xl">Administrá tu excursión</span>
          <span className="block font-bold my-3">Cargar tu excursión es muy fácil</span>

          <div className="mb-5">
            <span className="font-bold">1 Contanos acerca de tu excursión</span>
            <span className="block">Compartí algunos datos básicos, como la ubicación y horarios.</span>
            <hr />
          </div>

          <div className="mb-5">
            <span className="font-bold">2 Hacé que se destaque</span>
            <span className="block">Agregá al menos 5 fotos más el título y la descripción. Nosotros te ayudamos.</span>
            <hr />
          </div>

          <div className="mb-5">
            <span className="font-bold">3 Terminá todo y publicá tu excursión</span>
            <span className="block">Establecé tu precio inicial y publica tu anuncio.</span>
          </div>

          <Link to={'/excursion/carga/pasos'} 
            className={`cursor-pointer flex w-full rounded-full btn btn-filled-2`}
            style={{ borderRadius: "20px" }}
          >
            Comenzar
            <button className="hidden"></button>
          </Link>
        </div>
        <div>
          <img src={portada} alt="" width={250} />
        </div>
      </div>
    </div>
  )
}

export default CargaExcursion